import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getBigbangCard } from '../../../../services/api';

class BigBang extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        bigbangData: {},
    };

    async componentDidMount() {
        const { content } = this.props;
        const bigbangData = await getBigbangCard(content);

        this.setState({
            bigbangData,
        });
    }

    render() {
        const { bigbangData } = this.state;

        return bigbangData?.weburl ? (
            <div className={styles.bigbangArticleBox}>
                <div className={styles.bigbangArticleFeed}>
                    <a href={bigbangData.weburl} className={styles.bigbangArticleFeedLink}>
                        {bigbangData?.logo && (
                            <div className={styles.bigbangArticleFeedImg}>
                                <img src={bigbangData.logo} className={styles.bigbangArticleFeedPic} />
                            </div>
                        )}
                        <div className={styles.bigbangArticleFeedText}>
                            {bigbangData?.title && (
                                <div className={styles.bigbangArticleFeedTitle}>{bigbangData.title}</div>
                            )}
                            {bigbangData?.fromText && (
                                <div className={styles.bigbangArticleFeedInfo}>{bigbangData.fromText}</div>
                            )}
                        </div>
                    </a>
                </div>
            </div>
        ) : null;
    }
}

export default BigBang;
